import { render, staticRenderFns } from "./image-uploader.vue?vue&type=template&id=bdd72cb8&scoped=true"
import script from "./image-uploader.vue?vue&type=script&lang=js"
export * from "./image-uploader.vue?vue&type=script&lang=js"
import style0 from "./image-uploader.vue?vue&type=style&index=0&id=bdd72cb8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd72cb8",
  null
  
)

export default component.exports